// Simple persistent store for last-known-good box statuses per page.
// Keys:
//   pageId: string (e.g., 'ftso-submissions', 'fdc-submissions')
//   boxKey: string (e.g., 'ENV|flare')
// Values:
//   status: 'green' | 'amber' | 'yellow' | 'red'

const LS_KEY = 'hm_last_good_status_v1';

function readAll() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(obj) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(obj || {}));
  } catch {}
}

function normalizeStatus(s) {
  const v = (s || '').toString().toLowerCase();
  if (v === 'yellow') return 'amber';
  if (v === 'green' || v === 'amber' || v === 'red') return v;
  return undefined;
}

export const LastGoodStatusStore = {
  get(pageId, boxKey) {
    try {
      const all = readAll();
      const page = all[pageId];
      if (page && typeof page === 'object') {
        const st = normalizeStatus(page[boxKey]);
        return st || undefined;
      }
      return undefined;
    } catch {
      return undefined;
    }
  },

  set(pageId, boxKey, status) {
    const st = normalizeStatus(status);
    if (!st) return;
    const all = readAll();
    const page = (all[pageId] && typeof all[pageId] === 'object') ? all[pageId] : {};
    if (page[boxKey] !== st) {
      page[boxKey] = st;
      all[pageId] = page;
      writeAll(all);
    }
  },

  getPage(pageId) {
    const all = readAll();
    const page = all[pageId];
    if (page && typeof page === 'object') return page;
    return {};
  }
};


